import { HDate } from "@hebcal/core";

const getOrdinalNum = (number) => {
    if (typeof number !== 'number') return '';

    const suffixes = ['th', 'st', 'nd', 'rd'];
    const lastDigit = number % 10;
    const lastTwoDigits = number % 100;
    return number + ((lastTwoDigits >= 11 && lastTwoDigits <= 13) ? 'th' : suffixes[lastDigit] || 'th');
};

export const convertToHebrewDate = (dateStr, language = 'he') => {
    try {
        if (!dateStr || typeof dateStr !== 'string') {
            return '';
        }

        let date;

        if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr)) {
            const [day, month, year] = dateStr.split('/');
            const isoDateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
            date = new Date(isoDateStr);
        } else {
            date = new Date(dateStr);
        }

        if (isNaN(date.getTime())) {
            return '';
        }

        const hDate = new HDate(date);
        console.log("מידע", hDate);
        if (language === 'en') {
            console.log("תאריך", hDate.renderGematriya());
            const hebrewDay = hDate.getDate();
            const hebrewMonth = hDate.getMonthName();
            const hebrewYear = hDate.getFullYear();
            const gregorianMonth = date.toLocaleString('en-US', {month: 'long'});
            const gregorianDay = date.getDate();

            const gregorianYear = date.getFullYear();
            // Format: "Adar 7th, 5731 (March 4th, 1971)"
            return `${hebrewMonth} ${getOrdinalNum(hebrewDay)}, ${hebrewYear}, (${gregorianMonth} ${getOrdinalNum(gregorianDay)}, ${gregorianYear})`;
        } else {
            // עבור עברית, נשתמש ב-renderGematriya עם הפרדה מותאמת
            const hebrewDate = hDate.renderGematriya();
            if (!hebrewDate) return '';

            // פיצול התאריך העברי לחלקים
            const dateParts = hebrewDate.split(' ');
            const year = dateParts[dateParts.length - 1];
            const dayMonth = dateParts.slice(0, -1).join(' ');

            // החזרת הפורמט: "ז׳ אדר, ה'תשל"ה"
            return `${dayMonth}, ${year}`;
        }
    } catch (error) {
        console.error('Error in convertToHebrewDate:', error);
        return '';
    }
};